



















import { defineComponent, computed, ref, onMounted, watchEffect, nextTick } from '@vue/composition-api';
import CouponItem from './coupon-item.vue';
import { useCouponStore } from '@/store/coupon';
import { storeToRefs } from 'pinia';
import { useCouponLock } from '@/hooks/use-coupon-lock';
import CouponDialog from './coupon-dialog/index.vue';
import { useCouponTaskDialog } from '@/hooks/use-coupon-task-dialog';

export default defineComponent({
  name: 'CouponList',
  props: {
    category: {
      type: String,
      default: 'hot',
    },
  },
  components: { CouponItem, CouponDialog },

  setup(prop) {
    const couponStore = useCouponStore();
    const { formattedCouponList, couponStateEndList } = storeToRefs(couponStore);
    const { isLock } = useCouponLock();
    // eslint-disable-next-line max-len
    const list = computed(() => formattedCouponList.value.filter((ele: { tabKey: string[] }) => (ele.tabKey || []).includes(prop.category)));
    // 券弹窗
    const couponDialog = ref<InstanceType<typeof CouponDialog> | null>(null);
    // 当前操作的券
    const currentCouponInfo = ref();
    /** 是否展示全局详情弹窗 - 券 */
    const { isShowCouponDetail } = useCouponTaskDialog();

    // 点击券，打开券详情弹窗
    function onCouponClick(couponInfo) {
      currentCouponInfo.value = couponInfo;
      nextTick(() => couponDialog.value?.showCouponInfo());
    }

    onMounted(() => {
      watchEffect(() => {
        isShowCouponDetail((couponId: string) => {
          const item = [
            ...formattedCouponList.value,
            ...couponStateEndList.value,
          ].find(coupon => coupon.couponId === couponId);
          if (!item) return;
          onCouponClick(item);
        });
      });
    });

    return {
      list,
      isLock,
      couponDialog,
      currentCouponInfo,
      onCouponClick,
    };
  },
});
